<template>
    <div class="forex-index">
        <page-navigate></page-navigate>
        <div>
            <div class="forex-wrapper cn">
                <forexMenu />
                <div class="forex-wrapper-body">
                    <h1 class="">财经日历</h1>
                    <div class="forex-title-intro">
                        提供38个国家/地区的实时宏观经济数据，追踪全球经济数据与事件发布时间，精准掌握行情波动的触发时点，助力高效布局与风险管理。
                    </div>
                    <section class="section1">
                        <iframe id="TCIframe" class="scrollbar-container" :src="TCIframe"></iframe>
                    </section>
                </div>

            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import forexMenu from '../../components/forex-menu/forex-menu.vue';


export default {

    data() {
        return {
            TCIframe: "",

        };
    },
    computed: {},
    created() {
        this.getUrl();
    },
    mounted() {

    },
    filters: {},
    methods: {
        getUrl() {
            const formData = new FormData();
            formData.append('lang', 'cs');
            fetch('https://ebccfd.com/TradingCentral/EconomicCalendar/', {
                method: 'POST',
                body: formData
            }).then((res) => {
                return res.text()
            }).then((res) => {
                this.TCIframe = res;
            }).catch(() => {

            })

        },
    },
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

.swiper-container {
    overflow: hidden;
    padding-bottom: 40rem;
}

.forex-wrapper .forex-title {
    color: var(--Text-Primary, #000);
    font-size: 64rem;
    font-style: normal;
    font-weight: 700;
    line-height: 72rem;
}

.forex-sub-title {
    margin-top: 24rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 20rem;
    font-style: normal;
    font-weight: 400;
    line-height: 28rem;
}

.search-box {
    margin-top: 56rem;
}

.section1 {
    margin-top: 56rem;
}

#ProductIframe,
#TCIframe {
    width: 100%;
    height: 654rem;
    border-radius: var(--Corner-Radius-RC12, 12rem);
    border: 1px solid #ebebeb;
}

#ProductIframe {
    height: 740rem;
    padding-top: 16rem;
}


.section3-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24rem 32rem;
    border-radius: var(--Corner-Radius-RC12, 12rem);
    border: 1px solid #ebebeb;
    background: var(--Neutral-BG_A, #fff);
    gap: 114rem;
}

.section3-content-left {
    display: flex;
    flex-direction: column;
}

.section3-content-right {
    flex-shrink: 0;
    width: 450rem;
}

.section3-content-right img {
    /* height: 215rem; */
}

::v-deep .section3-swiper-wrapper {
    position: relative;
    padding-bottom: 40rem;
    perspective: 1200px;
}

/* 2. 启用 3D 渲染上下文 */
::v-deep .section3-swiper-wrapper .swiper-wrapper {
    transform-style: preserve-3d;
}

/* .section3-swiper-wrapper::before {
  content: "";
  height: 100%;
  width: 40rem;
  background: linear-gradient(270deg, rgba(256, 256, 256, 0) 0%, #fff 100%);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
}
.section3-swiper-wrapper::after {
  content: "";
  height: 100%;
  width: 40rem;
  background: linear-gradient(90deg, rgba(256, 256, 256, 0) 0%, #fff 100%);
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99;
} */
::v-deep .section3-swiper-wrapper .swiper-slide {
    width: 380rem;
    height: 290rem;
    display: flex;
    justify-content: center;
    align-items: center;
    /* opacity: 0.7; */
    transition: all 0.4s ease;
    /* transform: scale(0.9); */
    border-radius: 8rem;
    background: #fafafa;
    opacity: 0.8;
    transition: transform 0.6s ease, opacity 0.6s ease;
    backface-visibility: hidden;
    will-change: transform;
    transform-style: preserve-3d;
    /* 必须！ */
}

/* 居中激活项：正面、不倾斜、最清晰 */
::v-deep .section3-swiper-wrapper .swiper-slide-active {
    transform: scale(1) rotateY(0deg) translateX(0);
    opacity: 1;
    z-index: 4;
    filter: blur(0);
    background: #fafafa;
}


::v-deep .section3-swiper-wrapper .swiper-slide::before {
    position: absolute;
    left: 0;
    top: 0;
    content: "";
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #f2f2f2, #fafafa);
    z-index: 3;
    opacity: 1;
    transition: all 0.42s;
    border-radius: 8rem;
}

::v-deep .section3-swiper-wrapper .swiper-slide-next::before {
    background: linear-gradient(90deg, #f2f2f2, #fafafa);
}

::v-deep .section3-swiper-wrapper .swiper-slide-active::before {
    opacity: 0;
}

/* 左侧项：向右倾斜（rotateY 负值） */
::v-deep .section3-swiper-wrapper .swiper-slide-prev {
    position: relative;
    transform: scale(.8) rotateY(30deg) translateX(25%);
    opacity: 0.9;
    z-index: 2;
    background: #f2f2f2;

}

/* 右侧项：向左倾斜（rotateY 正值） */
::v-deep .section3-swiper-wrapper .swiper-slide-next {
    transform: scale(.8) rotateY(-30deg) translateX(-25%);
    opacity: 0.9;
    z-index: 2;
    background: #f2f2f2;
}



.section3-item-title {
    color: var(--Text-Primary, #000);
    font-size: 14rem;
    font-style: normal;
    font-weight: 500;
    line-height: 24rem;
    text-align: center;
    margin-bottom: 16rem;
}

::v-deep .swiper-pagination-bullet {
    /* width: 10px;
  height: 4px; */
    display: inline-block;
    background: #bbb;
    opacity: 0.5;
    /* border-radius: 2px; */
}

::v-deep .swiper-pagination-bullet-active {
    background: rgba(0, 0, 0, 0.24);
    /* 当前激活分页的颜色 */
    opacity: 1;
}

.section3-title {
    color: var(--Text-Primary, #000);
    font-size: 20rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.4;
    /* 140% */
}

.section3-img-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 7rem;
}

.section3-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.section3-item-img {
    width: 82%;
    margin: 0 auto;
}

/* .move-left-10 {
  width: calc(100% + 12px);
  transform: translateX(-12px);
} */
.section3-inner-img {
    flex-shrink: 0;
    height: 160rem;
}

.section3-item-text {
    color: #000;
    font-size: 12rem;
    font-weight: 400;
}

.section3-img-inner-box {
    display: flex;
    gap: 5rem;
}

.section3-img-inner-left,
.section3-img-inner-right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-shrink: 0;
    width: 85rem;
}

.section3-img-inner-left .section3-item-text {
    text-align: right;
}

.ar .section3-img-inner-left .section3-item-text {
    text-align: left;
}

.section3-img-inner-right .section3-item-text {}

.section3-intro {
    margin-top: 16rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    /* 150% */
}

.section3-btn-box {
    display: flex;
    gap: 12rem;
    margin-top: 64rem;
}

.section4-content {
    display: flex;
    gap: 20rem;
    margin-top: 28rem;
}

.section5-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20rem;
}

.section5-item {
    border-radius: var(--Corner-Radius-RC12, 12rem);
    border: 1px solid #ebebeb;
    background: var(--Neutral-BG_A, #fff);
    padding: 32rem 24rem 32rem 32rem;
    width: calc(33.3% - 13.4rem);
    transition: border 0.3s;
}

.section5-item:hover {
    border: 1px solid #a52933;
    background: url("../../assets/image/forex/index/section5-card-bg-dot.png") no-repeat;
    background-size: 144rem 80rem;
    background-position: right top;
}

.section5-item-btn {
    margin-top: 16rem;
    display: flex;
    justify-content: flex-end;
}

.section5-item:hover .section5-item-btn {
    color: #a52933;
}

.section5-item-icon {
    width: 32rem;
}

.section5-item-title {
    margin-top: 24rem;
    color: var(--ebc--, #232222);
    font-size: 18rem;
    font-style: normal;
    font-weight: 500;
    line-height: 26rem;
    /* height: 52rem; */
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 溢出时显示省略号 */
}

.section5-item-intro {
    margin-top: 16rem;
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem;
}

@media (max-width: 1440px) {
    .section3-content-right {
        width: 500rem;
    }

    .section3-swiper-wrapper .swiper-slide {
        width: 400rem;
        height: 290rem;
    }
}

@media (max-width: 996px) {

    #ProductIframe,
    #TCIframe {
        border-radius: 16rem;
    }

    .forex-wrapper .forex-title {
        /* text-align: center; */
        font-size: 64rem;
        line-height: 80rem;
    }

    .forex-sub-title {
        font-size: 28rem;
        line-height: 44rem;
        /* text-align: center; */
    }

    .search-box {
        margin-top: 64rem;
    }

    #TCIframe {
        height: 1300rem;
    }

    .section3-swiper-wrapper {
        padding-bottom: 70rem;
    }

    .section3-content {
        flex-direction: column;
        padding: 48rem 32rem;
        border-radius: 16rem;
    }

    .section3-content-left {
        order: 2;
    }

    .section3-content-right {
        order: 1;
    }

    .section3-content-right img {
        /* height: 292rem; */
    }

    .section3-content-right {
        width: 600rem;
    }

    .section3-item-img {
        width: 76%;
    }

    .section3-swiper-wrapper .swiper-slide {
        width: 480rem;
        height: 350rem;
    }

    .section3-item-title {
        font-size: 16rem;
    }

    .section3-item-text {
        font-size: 14rem;
    }

    .section3-icon {
        display: none;
    }

    .section3-title {
        margin: 0 auto 0;
        font-size: 36rem;
        line-height: 52rem;
        text-align: center;
        max-width: 90%;
    }

    .section3-intro {
        font-size: 28rem;
        line-height: 44rem;
        text-align: center;
    }

    .section3-btn-box {
        margin-top: 64rem;
        justify-content: center;
        gap: 24rem;
    }

    #ProductIframe {
        height: 750rem;
    }

    .section5-content {
        flex-direction: column;
        gap: 32rem;
    }

    .section5-item {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 40rem;
        gap: 32rem;
        border-radius: 16rem;
    }

    .section5-item-icon {
        flex-shrink: 0;
        width: 64rem;
        height: 64rem;
    }

    .section5-item-title {
        position: relative;
        margin-top: 0;
        font-size: 32rem;
        line-height: 48rem;
        font-weight: 400;
        flex-grow: 1;
        padding-right: 40rem;
    }

    .section5-item-title::after {
        position: absolute;
        right: 0;
        top: 0;
        content: "\e618";
        font-size: 40rem;
        font-family: "iconfont" !important;
        color: #c2c2c2;
    }

    .section5-item-intro {
        display: none !important;
    }

    .section5-item-btn {
        display: none !important;
    }
}
</style>